import React from 'react'
import { useTranslation } from 'react-i18next'
import GenericStatsDetails from './GenericStatsDetails'

const Shops: React.FC = () => {
  const { t } = useTranslation()

  return <GenericStatsDetails entity='shop' entityTranslation={t('global.stats.shops')} icon='warehouse' />
}

export default Shops
